import { z } from "zod";

import { REQUIRED_ERR_MSG } from "../../constants";

const zTrue = z.literal<boolean>(true, {
  error: REQUIRED_ERR_MSG,
});

export const zDocuments = z.object({
  entity_registration_confirmed: zTrue,
  entity_operating_confirmed: zTrue,
  entity_formation_confirmed: zTrue,
  authorized_individual_id_confirmed: zTrue,
  ubo_id_confirmed: zTrue,
  entity_registration_uploaded: zTrue,
  entity_operating_uploaded: zTrue,
  entity_formation_uploaded: zTrue,
  // conditional tax fields
  w_8ben_uploaded: z.boolean(),
  w9_uploaded: z.boolean(),
  w_8bene_uploaded: z.boolean(),
});

export type Documents = z.infer<typeof zDocuments>;
